// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var VolatilityLabBasis;
(function (VolatilityLabBasis) {
    VolatilityLabBasis[VolatilityLabBasis["StrikePrices"] = 0] = "StrikePrices";
    VolatilityLabBasis[VolatilityLabBasis["Delta"] = 1] = "Delta";
})(VolatilityLabBasis || (VolatilityLabBasis = {}));
export function getVolatilityLabBasisKey(value) {
    switch (value) {
        case VolatilityLabBasis.StrikePrices:
            return 'property.StrikePrices';
        case VolatilityLabBasis.Delta:
            return 'property.Delta';
        default:
            return '';
    }
}
